import { CellConfig } from "shared/components/UniversalTable/components/UniversalTableRow";
import { Eye } from "@phosphor-icons/react";
import {
  AccessControlItem,
  AccessType,
  ACCESS_TYPE_LABELS,
  ACCESS_TYPE_COLORS,
} from "../types/accessControl";

interface AccessControlCellHandlers {
  onViewDetail: (row: AccessControlItem) => void;
}

export const createAccessControlCells = (
  row: AccessControlItem,
  handlers?: AccessControlCellHandlers,
): CellConfig[] => {
  const typeBadge = row.accessType ? (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${ACCESS_TYPE_COLORS[row.accessType as AccessType]}`}
    >
      {ACCESS_TYPE_LABELS[row.accessType as AccessType]}
    </span>
  ) : (
    <span className="text-neutral-secondary-mid text-sm">-</span>
  );

  return [
    {
      id: "building",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.building?.id || row.buildingId || "-"}
        </span>
      ),
    },
    {
      id: "unit",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.unit?.id || row.unitId || "-"}
        </span>
      ),
    },
    {
      id: "accessType",
      content: typeBadge,
    },
    {
      id: "keyLocation",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.keyLocation || (
            <span className="text-neutral-secondary-mid">-</span>
          )}
        </span>
      ),
    },
    {
      id: "additionalInfo",
      content: (
        <span className="text-neutral-primary text-sm">
          {row.additionalInfo || (
            <span className="text-neutral-secondary-mid">-</span>
          )}
        </span>
      ),
    },
    {
      id: "detail",
      content: (
        <div className="flex justify-end">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handlers?.onViewDetail(row);
            }}
            className="text-moss-primary hover:text-moss-primary/80 transition-colors"
          >
            <Eye size={18} />
          </button>
        </div>
      ),
    },
  ];
};
